import { Box, Text, Icon, Switch } from "@oneloop/jopijs";
import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import style from "./wrapperEdition.module.scss";

export default function WrapperEdition({
  eye = true,
  title,
  children,
  enabled,
  handleShow,
  disabledOff = false,
  typeOfData,
  ...props
}) {
  const [show, setShow] = useState(enabled);
  const { isEdition } = useSelector((ste) => ste.FichaInfoSlice);

  useEffect(() => {
    if (isEdition) {
      setShow(enabled);
    }
  }, [enabled, isEdition]);

  const toogleShowEnabled = () => {
    if (disabledOff && show) return;
    handleShow(eye && title ? title : !show);
  };
  if (!isEdition) return children;

  return (
    <Box
      __css={{ ...props }}
      width={!eye ? "100%" : ""}
      className={`${eye ? style.cardEye : style.cardSwitch} ${
        eye && !show && style.disabledEye
      } ${!eye && !show && style.switchOff}
      ${typeOfData === "operations" ? style.operation : ""}`}
      onClick={eye ? toogleShowEnabled : null}
    >
      {!eye && (
        <Box
          __css={{ border: !show && "none" }}
          className={`${style.switchHeader} ${!show && style.switchOff}`}
        >
          <Text fontSize="14px" fontWeight="700" color="var(--neutralGray1)">
            {title}
          </Text>
          <Switch
            data-testid={`${typeOfData}-switch`}
            aria-checked={show}
            onClick={toogleShowEnabled}
          />
        </Box>
      )}
      <Box
        __css={{ padding: !eye && "16px" }}
        className={`${style.content} ${
          !eye && !show && style.disabledSwhitchContent
        }`}
      >
        {((!eye && show) || eye) && children}
      </Box>
      {eye && (
        <Box
          data-testid={`${typeOfData}-eye`}
          __css={{
            marginLeft: "-18px",
            borderColor: !show && "red",
            minWidth: "40px",
          }}
          className={`${style.iconEyeContainer} ${
            disabledOff && style.disabledOff
          }`}
        >
          <Icon
            icon={`${show ? "icon-ver" : "icon-ocultar"}`}
            color={show && disabledOff ? "#dde5e9" : "red"}
            fontSize="16px"
          />
        </Box>
      )}
      {eye && !show && <Box className={style.disabledShadow}>-</Box>}
    </Box>
  );
}
